import { IconButton } from "@chakra-ui/react";
import { t } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { useToggle } from "react-use";
import { Icon } from "./Icon";
import { TextField, type TextFieldProps } from "./TextField";

export type PasswordFieldProps = Omit<
  TextFieldProps,
  "type" | "connectedRight"
>;
export const PasswordField = observer(function PasswordField(
  props: PasswordFieldProps,
) {
  const [showPassword, toggleShowPassword] = useToggle(false);

  return (
    <TextField
      {...props}
      type={showPassword ? "text" : "password"}
      placeholder={t`Enter new password`}
      height="var(--input-height)"
      connectedRight={
        <IconButton
          aria-label={showPassword ? t`Hide password` : t`Show password`}
          colorScheme="grey"
          icon={
            <Icon
              name={showPassword ? "eye-striked-through" : "eye"}
              color="inherit"
            />
          }
          onClick={toggleShowPassword}
          size="sm"
          variant="ghost"
        />
      }
    />
  );
});
